var o={confirmDialog:"lds-confirm-dialog",withoutMessage:"lds-confirm-dialog--without-message"};export{o as default};
